// extracted by mini-css-extract-plugin
module.exports = {"button":"google-pay-button_button__H_oXw"};